import { Navigate, Routes, Route, useLocation } from "react-router-dom";
import { Dialog } from "cerulean";
import { useLocalization } from "@fluent/react";
import AppDownloadDialogBody from "./AppDownloadDialogBody";
import DownloadTransactionsDialog from "../DownloadTransactionsDialog";

interface DashboardDialogProps {
  isOpen: boolean;
  androidUrl: string;
  appleUrl: string;
  fiName: string;
  closeDialog: () => void;
}

const DashboardDialog = ({
  isOpen,
  fiName,
  androidUrl,
  appleUrl,
  closeDialog,
}: DashboardDialogProps) => {
  const location = useLocation();
  const { l10n } = useLocalization();

  // Determine dialog title based on current route
  const getDialogTitle = () => {
    if (location.pathname.includes("/transactions")) {
      return l10n.getString(
        "title-download-transactions",
        null,
        "Download transactions"
      );
    }
    return l10n.getString(
      "title-download-mobile-app",
      null,
      "Download the mobile app"
    );
  };

  return (
    <Dialog
      isOpen={isOpen}
      onUserDismiss={closeDialog}
      title={getDialogTitle()}
      width="500px"
    >
      <div className="margin--top--s" />
      <Routes>
        <Route
          path="/app_download"
          element={
            <AppDownloadDialogBody
              fiName={fiName}
              androidUrl={androidUrl}
              appleUrl={appleUrl}
            />
          }
        />
        <Route
          path="/transactions"
          element={<DownloadTransactionsDialog closeDialog={closeDialog} />}
        />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Dialog>
  );
};

export default DashboardDialog;
